import toast from "@com/dialogs/Toast/index.js";
import message from "@com/dialogs/Message/index.js";

import store from "@/store/index.js"
export default {
  methods: {
    /**@param {String} msg */
    toast(msg) {
      return toast(msg);
    },

    /**@param {{title:string,html:string}} param0 */
    $message({ title, html, confirm }) {
      return message({ title, html, confirm });
    },

    /**
     * 埋点
     * @param {number} log_type 操作行为: 1打开访问, 2点击下载, 3登录，4抽奖，5领奖
     * @param {number} module_id 活动模块id
     */
    async Track(log_type, module_id = '') {
      store.dispatch('TRACK', log_type, module_id);
    }
  }
};